import { render, staticRenderFns } from "./Sender.vue?vue&type=template&id=77312ebf&scoped=true"
import script from "./Sender.vue?vue&type=script&lang=js"
export * from "./Sender.vue?vue&type=script&lang=js"
import style0 from "./Sender.vue?vue&type=style&index=0&id=77312ebf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77312ebf",
  null
  
)

export default component.exports